/**
 * <lp-fav> — favourite / wishlist toggle for predictive-search product cards.
 *
 * Thin wrapper around the shared store in lp-wishlist.js (window.LPWishlist),
 * so a heart toggled here syncs with the product grids, carousels and the
 * /pages/wishlist page. Re-initialises on every (re-)connect so it survives
 * the predictive-search results being morphed in and out.
 */
class LpFav extends HTMLElement {
  connectedCallback() {
    this.productId = String(this.dataset.productId || '');
    this.button = this.querySelector('button') || this;
    this.reflect();

    if (!this._bound) {
      this._bound = true;
      this.addEventListener('click', this._onClick, true);
      document.addEventListener('lp:wishlist:change', this.reflect);
    }
  }

  disconnectedCallback() {
    document.removeEventListener('lp:wishlist:change', this.reflect);
    this._bound = false;
  }

  reflect = () => {
    const on = !!(window.LPWishlist && window.LPWishlist.has(this.productId));
    this.button.setAttribute('aria-pressed', on ? 'true' : 'false');
    this.classList.toggle('is-fav', on);
  };

  _onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!window.LPWishlist) return;

    let meta = {};
    try {
      meta = JSON.parse(this.dataset.wishlist || '{}');
    } catch (_) {
      /* fall back to id-only */
    }
    window.LPWishlist.toggle(this.productId, meta);
    this.reflect();
  };
}

if (!customElements.get('lp-fav')) {
  customElements.define('lp-fav', LpFav);
}
